import styled from 'styled-components';
import { bpMobilePhablet, backgroundPrimary } from '../../styles/_theme-variables';

export const Content = styled.div`
    position: relative;
    background-color: ${backgroundPrimary};

    @media screen and (min-width: ${bpMobilePhablet}) {
        margin-top: -4em;
        padding: 2em;
    }
`;